// extracted by mini-css-extract-plugin
export default {"CurrentXPBadge":"RanksModal_CurrentXPBadge__eUFV2","RanksWrapper":"RanksModal_RanksWrapper__fdX1O"};